<span class="date">{{ getDateText() }}</span>
